module.exports = __webpack_public_path__ + "img/yjsq.b5a6ea2b.svg";